const deleteFromObjByKeys = (obj, keys) => {
  const result = {}

  Object.entries(obj).forEach(([key, value]) => {
    if (!keys.includes(key)) result[key] = value
  })

  return result
}

export default deleteFromObjByKeys
